import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const BRUSH_STROKES = "https://static.wixstatic.com/media/84770f_41b705d538ba49888600adbc72ada7da~mv2.png/v1/fill/w_480,h_1100,al_c,q_85,enc_avif,quality_auto/84770f_41b705d538ba49888600adbc72ada7da~mv2.png";

const CHAPTERS = [
  { number: '01', text: 'Coffee with a purpose.' },
  { number: '02', text: 'Community with a VIBE.' },
  { number: '03', text: 'Rooted in community, art, and culture.' },
  { number: '04', text: 'Come for the coffee. Stay for the VIBE.' }
];

const Chapter = ({ number, text, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: index * 0.08 }}
    className="flex items-baseline gap-6 border-t border-[#f4ede3]/10 py-10 first:border-t-0 sm:gap-12 sm:py-14"
  >
    <span className="chapter-number shrink-0 text-5xl sm:text-7xl">{number}</span>
    <p className="font-display text-[clamp(1.75rem,4.5vw,3.75rem)] font-light leading-[1.08] tracking-tight text-[#f4ede3]">
      {text}
    </p>
  </motion.div>
);

const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const brushY = useTransform(scrollYProgress, [0, 1], ['-12%', '12%']);

  return (
    <section
      ref={ref}
      data-testid="manifesto-section"
      className="relative overflow-hidden bg-[#14100d] px-6 py-28 sm:px-12 sm:py-40"
    >
      {/* Parallax brush-stroke texture */}
      <motion.img
        src={BRUSH_STROKES}
        alt=""
        aria-hidden="true"
        style={{ y: brushY }}
        className="pointer-events-none absolute -right-24 top-0 h-[130%] w-auto opacity-[0.16] mix-blend-screen"
      />

      <div className="relative mx-auto max-w-5xl">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="font-body mb-14 text-[11px] font-medium uppercase tracking-[0.45em] text-[#f2a33c] sm:mb-20"
        >
          The Manifesto — Welcome to Vibe Café
        </motion.p>

        {CHAPTERS.map((chapter, index) => (
          <Chapter key={chapter.number} {...chapter} index={index} />
        ))}

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-body mt-14 max-w-2xl text-base leading-relaxed text-[#b8ac9c] sm:text-lg"
        >
          We're more than a place to grab your morning cup. Every cup, conversation, and
          connection is part of something bigger — a space where people feel welcomed,
          inspired, and like they belong. Celebrating Black excellence, creativity,
          entrepreneurship, and the unique energy of Pottstown.
        </motion.p>
      </div>
    </section>
  );
};

export default Manifesto;
